<div class="detailed-entity-card">
    <div class="entity-card-header justify-content-between">
        <div class="entity-icon">
            <img width="48" height="48" src="assets/svg/Fan.svg" />
        </div>
        <div class="entity-details">
            <h2 class="entity-name">{{locationDetails?.label}}</h2>
            <p class="entity-class">{{locationDetails?.objectClassLabel}}</p>
        </div>
        @if (locationDetails?.pinned) {
            <eon-ui-icon
                class="top-right-position cursor-pointer"
                name="bookmark"
                (click)="togglePin($event, locationDetails)"
            ></eon-ui-icon>
        } @else {
            <eon-ui-icon
                class="top-right-position cursor-pointer"
                name="bookmark_outline"
                (click)="togglePin($event, locationDetails)"
            ></eon-ui-icon>
        }
    </div>
    <div class="entity-card-header justify-content-between">
        <div class="entity-details">
            <h2 class="entity-name"><b>Data Point Relationships</b></h2>
        </div>
    </div>
    <div class="entity-card-content">
        <div class="entity-top-details">
            <p><b>Sub Locations:</b>&nbsp;
                @if (locationDetails?.hasPartRelationsList?.length) {
                    @for (item of locationDetails?.hasPartRelationsList; track $index) {
                        <a href="" [routerLink]="['/locations', item.id]">{{item.name}}</a>
                    }
                } @else {
                    <span>N/A</span>
                }
            </p>
            <p><b>Is Location Of:</b> &nbsp;
                @if (locationDetails?.isLocationOfList?.length) {
                    @for (item of locationDetails?.isLocationOfList; track $index) {
                        <a href="" [routerLink]="[item.entityType === 'EQUIPMENT' ? '/equipments' : '/collections', item.id]">{{item.name}}</a>
                    }
                } @else {
                    <span>N/A</span>
                }
            </p>
        </div>
    </div>

    <div class="entity-card-content p-0">
        <cc-smart-alerts [alerts]="locationDetails?.smartAlerts"></cc-smart-alerts>
    </div>

    @if (locationDetails?.sensorsAndStatusDatapointsList?.length) {
        <div class="entity-card-header justify-content-between">
            <div class="entity-details">
                <h2 class="entity-name"><b>Sensors & Status</b></h2>
            </div>
        </div>
        <div class="entity-card-content">
            <cc-entity-points [points]="locationDetails.sensorsAndStatusDatapointsList" [pointsStatus]="pointsStatus"></cc-entity-points>
        </div>
    }
    @if (locationDetails?.alarmsDatapointsList?.length) {
        <div class="entity-card-header justify-content-between">
            <div class="entity-details">
                <h2 class="entity-name"><b>Alarms</b></h2>
            </div>
        </div>
        <div class="entity-card-content">
            <cc-entity-points [points]="locationDetails.alarmsDatapointsList" [pointsStatus]="pointsStatus"></cc-entity-points>
        </div>
    }
    @if (locationDetails?.commandsDatapointsList?.length) {
        <div class="entity-card-header justify-content-between">
            <div class="entity-details">
                <h2 class="entity-name"><b>Commands</b></h2>
            </div>
        </div>
        <div class="entity-card-content">
            <cc-entity-points [points]="locationDetails.commandsDatapointsList" [pointsStatus]="pointsStatus"></cc-entity-points>
        </div>
    }
    @if (locationDetails?.setpointsAndParametersDatapointsList?.length) {
        <div class="entity-card-header justify-content-between">
            <div class="entity-details">
                <h2 class="entity-name"><b>Setpoints & Parameters</b></h2>
            </div>
        </div>
        <div class="entity-card-content">
            <cc-entity-points [points]="locationDetails.setpointsAndParametersDatapointsList" [pointsStatus]="pointsStatus"></cc-entity-points>
        </div>
    }
    @if (locationDetails?.schedulesList?.length) {
        <div class="entity-card-header justify-content-between">
            <div class="entity-details">
                <h2 class="entity-name"><b>Schedules</b></h2>
            </div>
        </div>
        <div class="entity-card-content">
            @for (schedule of locationDetails?.schedulesList; track $index) {
                <div class="entity-row">
                    <div class="first-col">
                        <span>{{schedule.comment || schedule.classLabel}}</span>
                    </div>
                    <div class="mid-col flex align-items-center justify-content-end margin-left-auto">
                        <span>{{schedule.presentValue}}</span>
                        <span class="icon-btn">
                            <img class="cursor-pointer" src="assets/icons/exception.svg"
                                (click)="showExceptionSchedule(schedule.pointUUID)" />
                        </span>
                        <span class="icon-btn">
                            <img class="cursor-pointer" src="assets/icons/schedule.svg"
                                (click)="showSchedule(schedule.pointUUID)" />
                        </span>
                    </div>
                </div>
            }
        </div>
    }
    <div
        class="entity-card-footer flex align-items-center justify-content-between"
    >
        <eon-ui-icon
            name="more"
            aria-label="more"
            class="hydrated"
        ></eon-ui-icon
        >
        @if (locationLink) {
            <cc-share-link [link]="locationLink"></cc-share-link>
        }
    </div>
</div>

@if (showScheduleDialog) {
    <p-dialog
        header="Weekly Schedule"
        [(visible)]="showScheduleDialog"
        [modal]="true"
        [breakpoints]="{ '640px': '90vw' }"
        [style]="{ width: '90vw', height: '95%' }"
    >
        @if (showScheduleDialog) {
            <cc-schedule-calendar
                [scheduleUUID]="selectedScheduleUUID"
            ></cc-schedule-calendar>
        }
    </p-dialog>
}

@if (showExceptionScheduleDialog) {
    <p-dialog
        header="Exception Schedule"
        [(visible)]="showExceptionScheduleDialog"
        [modal]="true"
        [breakpoints]="{ '640px': '90vw' }"
        [style]="{ width: '90vw', height: '95%' }"
    >
        @if (showExceptionScheduleDialog) {
            <cc-exception-schedule-table
                [exceptionScheduleUUID]="selectedExceptionScheduleUUID"
            ></cc-exception-schedule-table>
        }
    </p-dialog>
}
